import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import {
  faHome,
  faEnvelope,
  faWrench,
  faCogs,
  faCopy,
  faGlobe,
  faShoppingCart,
  faBullhorn,
  faWifi,
  faHistory,
  faAnalytics,
  faCalendarAlt,
  faMobileAlt,
} from '@fortawesome/pro-solid-svg-icons'

import FEATURES from '../constants/features'
import NewEquipmentMenu from '../components/NewEquipmentMenu'
import NewsMenu from '../components/NewsMenu'
import TrainingIcon from '../icons/TrainingIcon'
import TrackerIcon from '../icons/TrackerIcon'
import ChainSystemIcon from '../icons/ChainSystemIcon'
import WarrantyIcon from '../icons/WarrantyIcon'
import PriceListIcon from '../icons/PriceListIcon'
import NewsIcon from '../icons/NewsIcon'
import { Module, ModuleName } from './index'

const customIconSize = '43px'

// TODO: deepfreeze or at least freeze
export const dashboard: Module = {
  name: 'dashboard',
  to: '/',
  title: 'dashboard',
  showInMenu: true,
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faHome,
    size: 'lg',
  },
}

export const contact: Module = {
  name: 'contact',
  to: '/contact-us',
  title: 'contact_info',
  menuItemTitle: 'contact',
  showInMenu: true,
  permissionCheckArgs: [FEATURES.CONTACT_INFO, ['R']],
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faEnvelope,
    size: 'lg',
  },
}

export const documents: Module = {
  name: 'documents',
  to: '/',
  title: 'documents',
  description: 'documents_description',
  external: true,
  showOnDashboard: true,
  showInMenu: true,
  permissionCheckArgs: [FEATURES.STORE_ACCESS, ['R']],
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faCopy,
    size: 'lg',
  },
  tileIconProps: {
    icon: faCopy,
    size: '4x',
  },
}

export const documentsAndManuals: Module = {
  name: 'documentsAndManuals',
  to: '/documents-and-manuals',
  title: 'documents_and_manuals',
  showOnDashboard: true,
  showInMenu: true,
  permissionCheckArgs: [FEATURES.DOCUMENTS_AND_MANUALS, ['R']],
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faCopy,
    size: 'lg',
  },
  tileIconProps: {
    icon: faCopy,
    size: '5x',
  },
}

export const myPartnersAndEquipment: Module = {
  name: 'myPartnersAndEquipment',
  to: '/my-partners-and-equipment',
  title: 'my_partners_and_equipment',
  showOnDashboard: true,
  showInMenu: true,
  permissionCheckArgs: [FEATURES.ASSET_FLEET, ['R']],
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faCogs,
    size: 'lg',
  },
  tileIconProps: {
    icon: faCogs,
    size: '5x',
  },
}

export const troubleshooting: Module = {
  name: 'troubleshooting',
  to: '/troubleshooting',
  title: 'troubleshooting',
  showOnDashboard: true,
  showInMenu: true,
  permissionCheckArgs: [FEATURES.TROUBLESHOOTING, ['R']],
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faWrench,
    size: 'lg',
  },
  tileIconProps: {
    icon: faWrench,
    size: '3x',
  },
}

export const eLearning: Module = {
  name: 'eLearning',
  to: '/elearning',
  title: 'elearning',
  description: 'elearning_description',
  showOnDashboard: true,
  showInMenu: true,
  permissionCheckArgs: [FEATURES.COURSES, ['R']],
  IconComponent: TrainingIcon,
  tileIconProps: {
    width: '48px',
  },
}

export const healthApp: Module = {
  name: 'healthApp',
  to: '/health-app',
  title: 'health_app',
  description: 'mobile_app',
  showOnDashboard: true,
  showInMenu: true,
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faMobileAlt,
    size: 'lg',
  },
  tileIconProps: {
    icon: faMobileAlt,
    size: '3x',
  },
}

export const store: Module = {
  name: 'store',
  to: '/store',
  title: 'store',
  description: 'store_description',
  external: true,
  showOnDashboard: true,
  showInMenu: true,
  permissionCheckArgs: [FEATURES.STORE_ACCESS, ['R']],
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faShoppingCart,
    size: 'lg',
  },
  tileIconProps: {
    icon: faShoppingCart,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const deliveryTracker: Module = {
  name: 'deliveryTracker',
  to: '/',
  title: 'delivery_tracker',
  description: 'delivery_tracker_description',
  external: true,
  showOnDashboard: true,
  showInMenu: true,
  permissionCheckArgs: [FEATURES.STORE_ACCESS, ['R']],
  IconComponent: TrackerIcon,
  tileIconProps: {
    width: '50px',
  },
}

export const statusControl: Module = {
  name: 'statusControl',
  to: '/',
  title: 'status_control',
  description: 'Additional information', // FIXME: add to translations?
  external: true,
  showOnDashboard: true,
  showInMenu: true,
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faWifi,
    size: 'lg',
  },
  tileIconProps: {
    icon: faWifi,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const chainSystem: Module = {
  name: 'chainSystem',
  to: '/chain-system',
  title: 'chain_system',
  description: 'chain_system_description',
  showExternalIcon: true,
  showOnDashboard: true,
  showInMenu: true,
  IconComponent: ChainSystemIcon,
  tileIconProps: {
    width: '50px',
  },
}

// SWF only
export const craneMaster: Module = {
  name: 'craneMaster',
  to: '/crane-master',
  title: 'crane_master',
  showOnDashboard: true,
  showInMenu: true,
  IconComponent: ChainSystemIcon,
  tileIconProps: {
    width: '50px',
  },
}

export const leadTimes: Module = {
  name: 'leadTimes',
  to: '/lead-times',
  title: 'lead_times',
  showOnDashboard: true,
  showInMenu: true,
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faHistory,
    size: 'lg',
  },
  tileIconProps: {
    icon: faHistory,
    style: {
      fontSize: '5em',
    },
  },
}

export const leadTimeDemo: Module = {
  name: 'leadTimeDemo',
  to: '/lead-time-demo',
  title: 'lead_times',
  showOnDashboard: true,
  showInMenu: true,
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faHistory,
    size: 'lg',
  },
  tileIconProps: {
    icon: faHistory,
    style: {
      fontSize: '5em',
    },
  },
}

export const businessDashboard: Module = {
  name: 'businessDashboard',
  to: '/business-dashboard',
  title: 'business_dashboard',
  description: 'business_dashboard_description',
  showOnDashboard: true,
  showInMenu: true,
  permissionCheckArgs: [FEATURES.BUSINESS_DASHBOARD, ['R']],
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faAnalytics,
    size: 'lg',
  },
  tileIconProps: {
    icon: faAnalytics,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const marketingBank: Module = {
  name: 'marketingBank',
  to: '/marketing-bank',
  title: 'marketing_bank',
  showOnDashboard: true,
  showInMenu: true,
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faBullhorn,
    size: 'lg',
  },
  tileIconProps: {
    icon: faBullhorn,
    style: {
      fontSize: '80px',
    },
  },
}

export const trainingCalendar: Module = {
  name: 'trainingCalendar',
  to: '/training-calendar',
  title: 'training_calendar',
  showOnDashboard: true,
  showInMenu: true,
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faCalendarAlt,
    size: 'lg',
  },
  tileIconProps: {
    icon: faCalendarAlt,
    style: {
      fontSize: '78px',
    },
  },
}

export const warranty: Module = {
  name: 'warranty',
  to: '/warranty',
  title: 'warranty',
  showOnDashboard: true,
  showInMenu: true,
  IconComponent: WarrantyIcon,
  tileIconProps: {
    width: '45px',
  },
  menuItemIconProps: {
    width: '24px',
  },
}

export const verlindeCom: Module = {
  name: 'verlindeCom',
  to: 'https://www.verlinde.com',
  title: 'verlinde_com',
  description: 'verlinde_com_description',
  external: true,
  showOnDashboard: true,
  showInMenu: true,
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faGlobe,
    size: 'lg',
  },
  tileIconProps: {
    icon: faGlobe,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const training: Module = {
  name: 'training',
  to: '',
  title: 'training',
  description: 'training_description',
  external: true,
  showOnDashboard: true,
  showInMenu: true,
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faCalendarAlt,
    size: 'lg',
  },
  tileIconProps: {
    icon: faCalendarAlt,
    size: '3x',
  },
}

// Verlinde specific
export const priceList: Module = {
  name: 'priceList',
  to: 'https://www.verlinde.com/mail/Verlinde-Tarif-Price-List-2021.pdf',
  title: 'price_list',
  description: 'price_list_description',
  external: true,
  showOnDashboard: true,
  showInMenu: true,
  IconComponent: PriceListIcon,
  tileIconProps: {
    width: '60px',
  },
}

export const mySWF: Module = {
  name: 'mySWF',
  to: 'https://www.swfkrantechnik.com/myswf/',
  title: 'my_swf',
  description: 'my_swf_description',
  external: true,
  showOnDashboard: true,
  showInMenu: true,
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faGlobe,
    size: 'lg',
  },
  tileIconProps: {
    icon: faGlobe,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const modalMenu: Module = {
  name: 'modalMenu',
  to: '/',
  title: 'new_equipment_configurators_and_spare_parts',
  description: 'chain_system_description',
  showOnDashboard: true,
  IconComponent: ChainSystemIcon,
  tileIconProps: {
    width: '78px',
  },
  modalContent: <NewEquipmentMenu />,
}

export const news: Module = {
  name: 'news',
  to: '/never', // So that it doesn't show as active in the side menu.
  title: 'verlinde_news',
  showOnDashboard: true,
  showInMenu: true,
  IconComponent: NewsIcon,
  tileIconProps: {
    width: '50px',
  },
  menuItemIconProps: {
    width: '24px',
  },
  modalContent: <NewsMenu />,
}

export const newsPriceList: Module = {
  name: 'newsPriceList',
  to: 'https://www.verlinde.com/mail/augmentation-septembre-2021.html',
  title: 'verlinde_news_price_list',
  description: '28/07/2021',
  external: true,
  IconComponent: Icon,
  tileIconProps: {
    icon: faGlobe,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const newsLeadTime: Module = {
  name: 'newsLeadTime',
  to: 'https://www.verlinde.com/mail/retard-de-livraison.html',
  title: 'verlinde_news_lead_time',
  description: '1/07/2021',
  external: true,
  IconComponent: Icon,
  tileIconProps: {
    icon: faGlobe,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const newsEuropont: Module = {
  name: 'newsEuropont',
  to: 'https://www.verlinde.com/mail/europont-notification.html',
  title: 'Europont Notification', // Not translated
  description: '14/09/2021',
  external: true,
  IconComponent: Icon,
  tileIconProps: {
    icon: faGlobe,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const newsMyVerlinde: Module = {
  name: 'newsMyVerlinde',
  to: 'https://www.verlinde.com/mail/myverlinde-notification.html',
  title: 'myVerlinde Notification', // Not translated
  description: '22/10/2021',
  external: true,
  IconComponent: Icon,
  tileIconProps: {
    icon: faGlobe,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const newsProductsAvailability: Module = {
  name: 'newsProductsAvailability',
  to: 'https://www.verlinde.com/mail/arret-produit.html',
  title: 'verlinde_news_products_availability',
  description: '8/11/2021',
  external: true,
  IconComponent: Icon,
  tileIconProps: {
    icon: faGlobe,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const newsEuropontVertex: Module = {
  name: 'newsEuropontVertex',
  to: 'https://www.verlinde.com/mail/update-europont.html',
  title: 'verlinde_news_europont_vertex',
  description: '16/11/2021',
  external: true,
  IconComponent: Icon,
  tileIconProps: {
    icon: faGlobe,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const newsEuropontUpdate: Module = {
  name: 'newsEuropontUpdate',
  to: 'https://www.verlinde.com/mail/notification-europont-16-11-21.html',
  title: 'verlinde_news_europont_update',
  description: '17/11/2021',
  external: true,
  IconComponent: Icon,
  tileIconProps: {
    icon: faGlobe,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const newsProductSupply: Module = {
  name: 'newsProductSupply',
  to: 'https://www.verlinde.com/mail/modif-fournitures.html',
  title: 'verlinde_news_product_supply',
  description: '29/11/2021',
  external: true,
  IconComponent: Icon,
  tileIconProps: {
    icon: faGlobe,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const newsPriceList2022JibCrane: Module = {
  name: 'newsPriceList2022JibCrane',
  to: 'https://www.verlinde.com/mail/tarif-potence.html',
  title: 'verlinde_news_price_list_2022_jib_crane',
  description: '16/12/2021',
  external: true,
  IconComponent: Icon,
  tileIconProps: {
    icon: faGlobe,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const newsExpertliftConfigurator: Module = {
  name: 'newsExpertliftConfigurator',
  to: 'https://www.verlinde.com/mail/config-expertlift.html',
  title: 'verlinde_news_expertlift_configurator',
  description: '20/12/2021',
  external: true,
  IconComponent: Icon,
  tileIconProps: {
    icon: faGlobe,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const newsPriceList2022Stagemaker: Module = {
  name: 'newsPriceList2022Stagemaker',
  to: 'https://www.verlinde.com//mail/tarif-2022-stagemaker.html',
  title: 'verlinde_news_price_list_2022_stagemaker',
  description: '11/01/2022',
  external: true,
  IconComponent: Icon,
  tileIconProps: {
    icon: faGlobe,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const newsPriceList2022: Module = {
  name: 'newsPriceList2022',
  to: 'https://www.verlinde.com//mail/tarif-2022.html',
  title: 'verlinde_news_price_list_2022',
  description: '12/01/2022',
  external: true,
  IconComponent: Icon,
  tileIconProps: {
    icon: faGlobe,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const stagemaker: Module = {
  name: 'stagemaker',
  to: 'https://www.stagemaker.com/',
  title: 'stagemaker',
  external: true,
  showOnDashboard: true,
  showInMenu: true,
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faGlobe,
    size: 'lg',
  },
  tileIconProps: {
    icon: faGlobe,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const leonardoProductConfigurator: Module = {
  name: 'leonardoProductConfigurator',
  to: 'https://leonardoproductconfigurator.donaticranes.com/donati/login',
  title: 'leonardo_product_configurator',
  description: 'leonardo_product_configurator_description',
  external: true,
  showOnDashboard: true,
  showInMenu: true,
  IconComponent: ChainSystemIcon,
  tileIconProps: {
    width: '50px',
  },
}

export const leonardoCraneSetConfigurator: Module = {
  name: 'leonardoCraneSetConfigurator',
  to: 'https://kc.allonweb.eu/?signin',
  title: 'leonardo_crane_set_configurator',
  description: 'leonardo_crane_set_configurator_description',
  external: true,
  showOnDashboard: true,
  showInMenu: true,
  IconComponent: ChainSystemIcon,
  tileIconProps: {
    width: '50px',
  },
}

export const electricChainHoists: Module = {
  name: 'electricChainHoists',
  to: 'https://donaticranes.com/en/documentation/brochures-and-user-guides-electric-chain-hoist',
  title: 'electric_chain_hoists',
  external: true,
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faCopy,
    size: 'lg',
  },
  tileIconProps: {
    icon: faCopy,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const electricWireRopeHoists: Module = {
  name: 'electricWireRopeHoists',
  to: 'https://donaticranes.com/en/documentation/sales-brochure-and-user-guide-electric-wire-rope-hoist',
  title: 'electric_wire_rope_hoists',
  external: true,
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faCopy,
    size: 'lg',
  },
  tileIconProps: {
    icon: faCopy,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const jibCranes: Module = {
  name: 'jibCranes',
  to: 'https://donaticranes.com/en/documentation/sales-brochure-and-user-guide-manual-and-electric-jib-cranes',
  title: 'jib_cranes',
  external: true,
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faCopy,
    size: 'lg',
  },
  tileIconProps: {
    icon: faCopy,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const driveUnits: Module = {
  name: 'driveUnits',
  to: 'https://donaticranes.com/en/documentation/sales-brochure-and-user-guide-drive-unit-cranes',
  title: 'drive_units',
  external: true,
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faCopy,
    size: 'lg',
  },
  tileIconProps: {
    icon: faCopy,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const endCarriages: Module = {
  name: 'endCarriages',
  to: 'https://donaticranes.com/en/documentation/sales-brochure-and-user-guide-endcarriages-bridge-cranes',
  title: 'end_carriages',
  external: true,
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faCopy,
    size: 'lg',
  },
  tileIconProps: {
    icon: faCopy,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const channelProfiles: Module = {
  name: 'channelProfiles',
  to: 'https://donaticranes.com/en/documentation/sales-brochure-and-user-guide-channel-profile',
  title: 'channel_profiles',
  external: true,
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faCopy,
    size: 'lg',
  },
  tileIconProps: {
    icon: faCopy,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const craneSets: Module = {
  name: 'craneSets',
  to: 'https://donaticranes.com/en/documentation/sales-brochure-and-user-guide-crane-set',
  title: 'crane_sets',
  external: true,
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faCopy,
    size: 'lg',
  },
  tileIconProps: {
    icon: faCopy,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const suspendedMonogirderBridgeCranes: Module = {
  name: 'suspendedMonogirderBridgeCranes',
  to: 'https://donaticranes.com/en/documentation/sales-brochure-and-user-guide-kit-suspended-monogirder-bridge-crane',
  title: 'suspended_monogirder_bridge_cranes',
  external: true,
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faCopy,
    size: 'lg',
  },
  tileIconProps: {
    icon: faCopy,
    style: {
      fontSize: customIconSize,
    },
  },
}

export const remoteMonitoring: Module = {
  name: 'remoteMonitoring',
  to: '/remote-monitoring',
  title: 'Remote Monitoring', // TODO
  showOnDashboard: true,
  showInMenu: true,
  IconComponent: Icon,
  menuItemIconProps: {
    icon: faWifi,
    size: 'lg',
  },
  tileIconProps: {
    icon: faWifi,
    style: {
      fontSize: customIconSize,
    },
  },
}

const defaultModules: Record<ModuleName, Module> = {
  dashboard,
  contact,
  documents,
  documentsAndManuals,
  myPartnersAndEquipment,
  troubleshooting,
  eLearning,
  healthApp,
  store,
  deliveryTracker,
  statusControl,
  chainSystem,
  craneMaster,
  leadTimes,
  leadTimeDemo,
  businessDashboard,
  marketingBank,
  trainingCalendar,
  warranty,
  verlindeCom,
  training,
  priceList,
  mySWF,
  modalMenu,
  news,
  newsPriceList,
  newsLeadTime,
  newsEuropont,
  newsMyVerlinde,
  newsProductsAvailability,
  newsEuropontVertex,
  newsEuropontUpdate,
  newsProductSupply,
  newsPriceList2022JibCrane,
  newsExpertliftConfigurator,
  newsPriceList2022,
  newsPriceList2022Stagemaker,
  stagemaker,
  leonardoProductConfigurator,
  leonardoCraneSetConfigurator,
  electricChainHoists,
  electricWireRopeHoists,
  jibCranes,
  driveUnits,
  endCarriages,
  channelProfiles,
  craneSets,
  suspendedMonogirderBridgeCranes,
  remoteMonitoring,
}

type ModuleProps = Partial<Omit<Module, 'name'>>

export function getBrandedModule(name: ModuleName, props?: ModuleProps) {
  const defaultModule = defaultModules[name]
  const brandedModule: Module = {
    ...defaultModule,
    ...props,
    tileProps: {
      ...defaultModule.tileProps,
      ...props?.tileProps,
    },
    menuItemIconProps: {
      ...defaultModule.menuItemIconProps,
      ...props?.menuItemIconProps,
    },
    tileIconProps: {
      ...defaultModule.tileIconProps,
      ...props?.tileIconProps,
    },
  }

  return brandedModule
}

export default defaultModules
